import React, { useCallback, useState } from 'react';
import { updatePhone,updatePassword,update } from '../../api/user';
import Button from '../button/button.jsx';
import Modal from '../modal/modal.jsx';
import PhoneInput from '../forms/phone-input/phone-input.jsx';
import VerifyCodeInput from '../forms/verify-code-input/verify-code-input.jsx';
import message from '../../components/message/message.jsx';
import PasswordInput from "../forms/password-input/pasword-input";
import UserNameInput from '../user-name-input/user-name-input.jsx';
import ErrorMsg from "../error-msg/error-msg";

const AccountResModal = ({ onClose, onSubmit, setUser, showLoading,page }) => {
    const PAGE_CHANGE_PHONE = 0;
    const PAGE_CHANGE_PASSWORD = 1;
    const PAGE_CHANGE_NAME = 2;
    const titles = [window.L("teach.user.changePhone"), window.L("teach.user.changePassword"),"修改用户名"];
    const [mobile, setMobile] = useState('');
    const [password, setPassword] = useState('');
    const [oldPassword,setOldPassword] = useState('');
    const [passwordConfirm, setPasswordConform] = useState('');
    const [inputCode, setInputCode] = useState('');
    const [inputCodeErr, setInputCodeErr] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [name, setName] = useState('');
    const onFinalSubmit = useCallback(() => {
        onSubmit();
    }, [onSubmit]);

    const handleLoginSuccess = (user) => {
        setUser(user);
        message.show(page === PAGE_CHANGE_PHONE?window.L('teach.user.successPhone'):page === PAGE_CHANGE_PASSWORD? window.L('teach.user.successPassword'):'用户名修改成功');
    }
    return (
        <Modal
            onClose={onClose}
            title={titles[page]}
        >
            <ErrorMsg errorMsg={errorMsg} />
            {
                page === PAGE_CHANGE_PHONE &&
                (
                    <React.Fragment>
                        <PasswordInput
                            onChange={v => {
                                setPassword(v);
                            }}
                        />
                        <PhoneInput
                            defaultValue={mobile}
                            onChange={v => {
                                setMobile(v);
                            }}
                        />
                        <VerifyCodeInput
                            mobile={mobile}
                            err={inputCodeErr}
                            onChange={v => {
                                setInputCodeErr('');
                                setInputCode(v);
                            }}
                        />
                        <div style={{ textAlign: 'center' }}>
                            <Button
                                label="提交"
                                onClick={async () => {
                                    if (mobile && inputCode && password) {
                                        try {
                                            showLoading(window.L('teach.user.changing'));
                                            let user = await updatePhone({
                                                phone: mobile,
                                                code: inputCode,
                                                password,
                                            });
                                            handleLoginSuccess(user);
                                            onFinalSubmit();
                                        } catch (error) {
                                            // eslint-disable-next-line no-alert
                                            if (error.msg || error.data) {
                                                setErrorMsg(error.msg || error.data);
                                            } else {
                                                setErrorMsg(error.toString());
                                            }

                                        }

                                    }
                                }}
                            />
                        </div>
                    </React.Fragment>
                )
            }
            {page == PAGE_CHANGE_PASSWORD &&
                (
                    <React.Fragment>
                        <PasswordInput
                            placeholder="当前密码"
                            onChange={v => {
                                setOldPassword(v);
                            }}
                        />
                        <PasswordInput
                            placeholder="请输入新密码"
                            onChange={v => {
                                setPassword(v);
                            }}
                        />
                        <PasswordInput
                            placeholder="请再输入一次新密码"
                            onChange={v => {
                                setPasswordConform(v);

                            }}
                            verify={v => {
                                if (!v.length) {
                                    throw new Error('请重复输入密码');
                                } else if (v != password) {
                                    throw new Error('两次输入密码不一致');
                                }
                                return true;
                            }}
                        />
                        <div style={{ textAlign: 'center' }}>
                            <Button
                                label="提交"
                                onClick={async () => {
                                    if (oldPassword && password && passwordConfirm) {
                                        try {
                                            showLoading(window.L('teach.user.changing'));
                                            let user = await updatePassword({
                                                old_password: oldPassword,
                                                password,
                                                password_confirmation: passwordConfirm,
                                            });
                                            handleLoginSuccess(user);
                                            onFinalSubmit();
                                        } catch (error) {
                                            // eslint-disable-next-line no-alert
                                            if (error.msg || error.data) {
                                                setErrorMsg(error.msg || error.data);
                                            } else {
                                                setErrorMsg(error.toString());
                                            }

                                        }
                                    }
                                }}
                            />
                        </div>
                    </React.Fragment>
                )
            }
            {
                page === PAGE_CHANGE_NAME &&
                (
                    <React.Fragment>
                        <UserNameInput
                            onChange={v => {
                                setName(v);
                            }}
                        />
                        <div style={{ textAlign: 'center' }}>
                            <Button
                                label="提交"
                                onClick={async () => {
                                    if (name) {
                                        try {
                                            showLoading(window.L('teach.user.changing'));
                                            let user = await update({
                                                name,
                                            });
                                            handleLoginSuccess(user);
                                            onFinalSubmit();
                                        } catch (error) {
                                            // eslint-disable-next-line no-alert
                                            if (error.msg || error.data) {
                                                setErrorMsg(error.msg || error.data);
                                            } else {
                                                setErrorMsg(error.toString());
                                            }

                                        }

                                    }
                                }}
                            />
                        </div>
                    </React.Fragment>
                )
            }
        </Modal>
    );
};

export default AccountResModal;
